import { AlertCircle } from "lucide-react";

export type ReportErrorCode = "EXP-GERAR" | "EXP-PRINT";

interface ReportErrorMessageProps {
  code: ReportErrorCode;
  detail: string;
}

export function ReportErrorMessage({ code, detail }: ReportErrorMessageProps) {
  return (
    <div
      className="report-error"
      role="alert"
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "0.7rem",
        padding: "0.8rem 0.9rem",
        border: "1px solid rgba(220, 38, 38, 0.24)",
        borderLeft: "3px solid #dc2626",
        borderRadius: "4px",
        background: "rgba(220, 38, 38, 0.07)",
        color: "var(--login-text)",
      }}
    >
      <AlertCircle
        aria-hidden="true"
        size={18}
        style={{ flex: "0 0 auto", marginTop: "0.1rem", color: "#dc2626" }}
      />
      <div style={{ minWidth: 0 }}>
        <strong
          style={{
            display: "block",
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: "0.95rem",
          }}
        >
          Não foi possível preparar o PDF
        </strong>
        <p
          style={{
            margin: "0.3rem 0 0",
            color: "var(--login-muted)",
            fontSize: "0.84rem",
            lineHeight: 1.45,
          }}
        >
          {detail}
        </p>
        <small
          style={{
            display: "block",
            marginTop: "0.4rem",
            color: "var(--login-muted)",
            fontFamily: "ui-monospace, monospace",
            fontSize: "0.72rem",
          }}
        >
          Código {code}
        </small>
      </div>
    </div>
  );
}
